import React from "react";
import { AlertCard, Button } from "@truevault/aquilo";
import clsx from "clsx";

export function PrivacyEmailSetupCard({
  onSetupClick,
  className,
}: {
  onSetupClick: () => void;
  className?: string;
}) {
  return (
    <AlertCard
      variant="info"
      showDefaultIcon={false}
      containerClasses={clsx(
        "!mt-0 !mb-[32px] w-full !bg-blue-50 !p-[24px] border-[1.5px] border-solid border-blue-600 relative min-h-[188px] overflow-hidden",
        className,
      )}
    >
      <div className="relative z-[1] max-w-[720px]">
        <div className="text-[16px] font-medium leading-[24px] text-blue-700">
          Complete your privacy email and a custom domain setup for your Privacy Center
        </div>
        <div className="mt-[12px] text-[14px] font-normal leading-[21px] text-blue-700">
          Your privacy email will be used to receive and respond to privacy requests received from
          your new Privacy Center site where users can submit privacy requests.
        </div>
        <div className="mt-[24px]">
          <Button
            color="primary"
            customSizeClassname="h-[38px] text-[14px] leading-[20px]"
            onClick={onSetupClick}
          >
            Set Up Privacy Email
          </Button>
        </div>
      </div>
      <PaperAirplaneDoodle />
    </AlertCard>
  );
}

function PaperAirplaneDoodle() {
  return (
    <svg
      className="pointer-events-none absolute bottom-[24px] right-0 hidden h-[58px] w-[300px] text-primary-600 md:block"
      viewBox="0 0 300 58"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M21.7 6.7L81.1 19.4C82.2 19.6 82.5 21.1 81.5 21.7L61.3 33.1L51.3 52.1C50.8 53.1 49.3 53 48.9 51.9L21 8.6C20.5 7.6 20.7 6.5 21.7 6.7Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M23.2 8.3L58.7 33.4M81 20.1L58.7 33.4M58.7 33.4L51.3 52.1"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M74 43C105.5 55.5 121.1 48.5 142.5 34.8C178.1 11.9 226.1 12.3 291.6 24.2"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.2"
        strokeDasharray="7 7"
      />
    </svg>
  );
}
